import { render, staticRenderFns } from "./CalendarEventSettingsDialog.vue?vue&type=template&id=e2e9808a&scoped=true&lang=pug&"
import script from "./CalendarEventSettingsDialog.vue?vue&type=script&lang=ts&"
export * from "./CalendarEventSettingsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarEventSettingsDialog.vue?vue&type=style&index=0&id=e2e9808a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e9808a",
  null
  
)

export default component.exports